// Фото игрока в круге; нет фото → инициалы (kind='initials', по умолчанию) или силуэт человека (kind='person', макет HQ-194).
import { useState } from 'react';
import { graphemes } from './graphemes';

export function Avatar({ src, name, size = 36, kind = 'initials' }: { src?: string | null; name: string; size?: number; kind?: 'initials' | 'person' }) {
  // Ошибка привязана к адресу: новый src (перестановка строк, смена команды) снова пробует картинку
  const [failedSrc, setFailedSrc] = useState<string | null>(null);
  const failed = !!src && failedSrc === src;
  const style = { width: size, height: size, borderRadius: '50%', flex: 'none' as const, objectFit: 'cover' as const,
    background: 'var(--ground)' };
  if (!src || failed) {
    const box = { ...style, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', color: 'var(--content-secondary)' };
    if (kind === 'person') {
      const icon = Math.round(size * 0.55);
      return <span aria-hidden="true" data-fallback="person" style={box}>
        <svg width={icon} height={icon} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="8" r="4" /><path d="M4 20.5c0-4 3.6-6.5 8-6.5s8 2.5 8 6.5" /></svg>
      </span>;
    }
    const initials = name.split(/\s+/).filter(Boolean).slice(0, 2).map((p) => graphemes(p)[0]).join('');
    return <span aria-hidden="true" style={{ ...box, fontSize: size * 0.36, fontWeight: 600 }}>{initials}</span>;
  }
  return <img src={src} alt="" style={style} loading="lazy" onError={() => setFailedSrc(src)} />;
}
